import React, { useCallback, useState } from 'react';

import { StyledItem } from 'modules/log/LogItem/styled';
import ShipperOrderTag from 'modules/shipper-order/Tag';
import { createTask } from 'modules/tasks/http';

import { setManualTaskOpened } from 'redux/modules/log/duck';
import StyledShipperOrders from '../LogItem/modes/CreateMode/styled';
import { Button, Checkbox, Flexer, Spacer, Text, Textarea } from '@ontruck/orc';
import { useDispatch } from 'react-redux';
import Schedule from 'modules/tasks/task-creation/Schedule';

export const t = {
  title: 'New Task',
  description: 'To which shipper order do you want to assign this task?',
  textarea_placeholder: 'Write task instructions',
  add: 'Add Task',
  cancel: 'Cancel',
};

const ManualTask = ({ className, shipperOrdersSkin, journeyId }) => {
  const dispatch = useDispatch();
  const [textAreaValue, setTextAreaValue] = useState('');
  const [selectedShipperOrder, setSelectedShipperOrder] = useState(null);
  const [date, setDate] = useState(new Date().toISOString());
  const [showScheduling, setShowScheduling] = useState(false);

  const shipperOrders = Object.keys(shipperOrdersSkin);
  const hasMultipleShipperOrders = shipperOrders.length > 1;

  const handleSelectShipperOrder = useCallback(
    (e, { name: shipperOrderId }) => {
      setSelectedShipperOrder(shipperOrderId);
    },
    [setSelectedShipperOrder]
  );

  const handleChangeDate = useCallback((date) => {
    setDate(date);
  }, []);

  const handleClose = useCallback(() => {
    dispatch(setManualTaskOpened(false));
  }, [dispatch]);

  const handleSave = useCallback(async () => {
    await createTask({
      journey_id: journeyId,
      comment: textAreaValue,
      ...(selectedShipperOrder ? { shipper_order_id: selectedShipperOrder } : {}),
      ...(showScheduling ? { scheduled_for: date } : {}),
    });
    handleClose();
  }, [journeyId, selectedShipperOrder, textAreaValue, handleClose, showScheduling, date]);

  const handleTextareaChange = useCallback(
    (e, { value }) => {
      setTextAreaValue(value);
    },
    [setTextAreaValue]
  );

  return (
    <StyledItem background="grey200" className={className}>
      <div className="manual-task">
        <Spacer mBottom="XS">
          <Text size="12" weight="bold" color="grey900">
            {t.title}
          </Text>
        </Spacer>
        {hasMultipleShipperOrders && (
          <>
            <Spacer mBottom="XS">{t.description}</Spacer>
            <StyledShipperOrders mBottom="XS" flexWrap="wrap">
              {shipperOrders.map((id) => (
                <Checkbox
                  name={id}
                  key={id}
                  onChange={handleSelectShipperOrder}
                  checked={id === selectedShipperOrder}
                  label={
                    <ShipperOrderTag
                      id={id}
                      shipperOrdersSkin={shipperOrdersSkin}
                      withinGroupage
                      copiable={false}
                      mRight="S"
                    />
                  }
                />
              ))}
            </StyledShipperOrders>
          </>
        )}

        <Spacer mBottom="XS">
          <Schedule
            showScheduling={showScheduling}
            setShowScheduling={setShowScheduling}
            handleChangeDate={handleChangeDate}
            date={date}
          />
        </Spacer>
        <Textarea
          fullWidth
          value={textAreaValue}
          labelType="hidden"
          height={'72px'}
          width={'100%'}
          onChange={handleTextareaChange}
          placeholder={t.textarea_placeholder}
        />
        <Flexer.Parent mTop="S" mBottom="XS" justifyContent="flex-end">
          <Flexer.Child>
            <Button skin="secondary" nude text={t.cancel} onClick={handleClose} />
          </Flexer.Child>
          <Flexer.Child mRight="XS">
            <Button
              skin="primary"
              text={t.add}
              disabled={hasMultipleShipperOrders && !selectedShipperOrder}
              onClick={handleSave}
            />
          </Flexer.Child>
        </Flexer.Parent>
      </div>
    </StyledItem>
  );
};

export default ManualTask;
